import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-row h-full",
  style: {"overflow":"hidden","min-width":"850px"}
}
const _hoisted_2 = {
  class: "main-content flex-1 pl-5 pr-5",
  style: {"overflow-y":"scroll"}
}
const _hoisted_3 = { class: "mt-3 mb-3" }
const _hoisted_4 = {
  key: 1,
  class: "flex-row-center w-100",
  style: {"height":"90vh"}
}
const _hoisted_5 = {
  class: "card",
  style: {"width":"320px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "登录管理后台", -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "login-name",
  class: "col-form-label"
}, " 用户名", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "login-pwd",
  class: "col-form-label"
}, " 密码", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NavBar),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_view)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postData.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.postData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postData.password) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.postData.password]
                ])
              ]),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args))),
                class: "btn btn-primary",
                style: {"width":"100%"}
              }, "登录")
            ])
          ])
        ])),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}